import { I18n } from "@assets/strings";
import { useObservable } from "micro-observables";
import React from "react";
import { allContentLanguages, ContentLanguage } from "@domain/lms/contentLanguage";
import { Selecter } from "@ui/components/inputs/selecter";
import { useEditorController } from "@ui/pages/lms/courseEditorPage/courseEditorController/editorControllerContext";

export const LanguageEditor: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ ...htmlProps }) => {
	const controller = useEditorController();
	const course = useObservable(controller.course);

	return (
		<Selecter
			{...htmlProps}
			placeholder={I18n.t("course.editor.language.placeholder")}
			value={course.language}
			onChange={(lang) => {
				controller.setLanguage(lang as ContentLanguage);
			}}
			options={allContentLanguages.map((lang) => ({
				value: lang,
				label: I18n.t(`language.${lang}`),
			}))}
		/>
	);
};
